const entities = {
  '0': { DDI: 0, name: 'Data Dictionary Version', unit: '', bitResolution: 1 },
  '1': {
    DDI: 1,
    name: 'Setpoint Volume Per Area Application Rate as [mm³/m²]',
    unit: 'mm³/m²',
    bitResolution: 0.01,
  },
  '2': {
    DDI: 2,
    name: 'Actual Volume Per Area Application Rate as [mm³/m²]',
    unit: 'mm³/m²',
    bitResolution: 0.01,
  },
  '3': {
    DDI: 3,
    name: 'Default Volume Per Area Application Rate as [mm³/m²]',
    unit: 'mm³/m²',
    bitResolution: 0.01,
  },
  '4': {
    DDI: 4,
    name: 'Minimum Volume Per Area Application Rate as [mm³/m²]',
    unit: 'mm³/m²',
    bitResolution: 0.01,
  },
  '5': {
    DDI: 5,
    name: 'Maximum Volume Per Area Application Rate as [mm³/m²]',
    unit: 'mm³/m²',
    bitResolution: 0.01,
  },
  '6': { DDI: 6, name: 'Setpoint Mass Per Area Application Rate', unit: 'mg/m²', bitResolution: 1 },
  '7': { DDI: 7, name: 'Actual Mass Per Area Application Rate', unit: 'mg/m²', bitResolution: 1 },
  '8': { DDI: 8, name: 'Default Mass Per Area Application Rate', unit: 'mg/m²', bitResolution: 1 },
  '9': { DDI: 9, name: 'Minimum Mass Per Area Application Rate', unit: 'mg/m²', bitResolution: 1 },
  '10': {
    DDI: 10,
    name: 'Maximum Mass Per Area Application Rate',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '11': {
    DDI: 11,
    name: 'Setpoint Count Per Area Application Rate',
    unit: '/m²',
    bitResolution: 0.001,
  },
  '12': {
    DDI: 12,
    name: 'Actual Count Per Area Application Rate',
    unit: '/m²',
    bitResolution: 0.001,
  },
  '13': {
    DDI: 13,
    name: 'Default Count Per Area Application Rate',
    unit: '/m²',
    bitResolution: 0.001,
  },
  '14': {
    DDI: 14,
    name: 'Minimum Count Per Area Application Rate',
    unit: '/m²',
    bitResolution: 0.001,
  },
  '15': {
    DDI: 15,
    name: 'Maximum Count Per Area Application Rate',
    unit: '/m²',
    bitResolution: 0.001,
  },
  '16': { DDI: 16, name: 'Setpoint Spacing Application Rate', unit: 'mm', bitResolution: 1 },
  '17': { DDI: 17, name: 'Actual Spacing Application Rate', unit: 'mm', bitResolution: 1 },
  '18': { DDI: 18, name: 'Default Spacing Application Rate', unit: 'mm', bitResolution: 1 },
  '19': { DDI: 19, name: 'Minimum Spacing Application Rate', unit: 'mm', bitResolution: 1 },
  '20': { DDI: 20, name: 'Maximum Spacing Application Rate', unit: 'mm', bitResolution: 1 },
  '21': {
    DDI: 21,
    name: 'Setpoint Volume Per Volume Application Rate',
    unit: 'mm³/m³',
    bitResolution: 1,
  },
  '22': {
    DDI: 22,
    name: 'Actual Volume Per Volume Application Rate',
    unit: 'mm³/m³',
    bitResolution: 1,
  },
  '23': {
    DDI: 23,
    name: 'Default Volume Per Volume Application Rate',
    unit: 'mm³/m³',
    bitResolution: 1,
  },
  '24': {
    DDI: 24,
    name: 'Minimum Volume Per Volume Application Rate',
    unit: 'mm³/m³',
    bitResolution: 1,
  },
  '25': {
    DDI: 25,
    name: 'Maximum Volume Per Volume Application Rate',
    unit: 'mm³/m³',
    bitResolution: 1,
  },
  '26': {
    DDI: 26,
    name: 'Setpoint Mass Per Mass Application Rate',
    unit: 'mg/kg',
    bitResolution: 1,
  },
  '27': { DDI: 27, name: 'Actual Mass Per Mass Application Rate', unit: 'mg/kg', bitResolution: 1 },
  '28': {
    DDI: 28,
    name: 'Default Mass Per Mass Application Rate',
    unit: 'mg/kg',
    bitResolution: 1,
  },
  '29': {
    DDI: 29,
    name: 'Minimum Mass Per Mass Application Rate',
    unit: 'mg/kg',
    bitResolution: 1,
  },
  '30': { DDI: 30, name: 'MaximumMass Per Mass Application Rate', unit: 'mg/kg', bitResolution: 1 },
  '31': {
    DDI: 31,
    name: 'Setpoint Volume Per Mass Application Rate',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '32': {
    DDI: 32,
    name: 'Actual Volume Per Mass Application Rate',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '33': {
    DDI: 33,
    name: 'Default Volume Per Mass Application Rate',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '34': {
    DDI: 34,
    name: 'Minimum Volume Per Mass Application Rate',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '35': {
    DDI: 35,
    name: 'Maximum Volume Per Mass Application Rate',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '36': {
    DDI: 36,
    name: 'Setpoint Volume Per Time Application Rate',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '37': {
    DDI: 37,
    name: 'Actual Volume Per Time Application Rate',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '38': {
    DDI: 38,
    name: 'Default Volume Per Time Application Rate',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '39': {
    DDI: 39,
    name: 'Minimum Volume Per Time Application Rate',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '40': {
    DDI: 40,
    name: 'Maximum Volume Per Time Application Rate',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '41': {
    DDI: 41,
    name: 'Setpoint Mass Per Time Application Rate',
    unit: 'mg/s',
    bitResolution: 1,
  },
  '42': { DDI: 42, name: 'Actual Mass Per Time Application Rate', unit: 'mg/s', bitResolution: 1 },
  '43': { DDI: 43, name: 'Default Mass Per Time Application Rate', unit: 'mg/s', bitResolution: 1 },
  '44': { DDI: 44, name: 'Minimum Mass Per Time Application Rate', unit: 'mg/s', bitResolution: 1 },
  '45': { DDI: 45, name: 'Maximum Mass Per Time Application Rate', unit: 'mg/s', bitResolution: 1 },
  '46': {
    DDI: 46,
    name: 'Setpoint Count Per Time Application Rate',
    unit: '/s',
    bitResolution: 0.001,
  },
  '47': {
    DDI: 47,
    name: 'Actual Count Per Time Application Rate',
    unit: '/s',
    bitResolution: 0.001,
  },
  '48': {
    DDI: 48,
    name: 'Default Count Per Time Application Rate',
    unit: '/s',
    bitResolution: 0.001,
  },
  '49': {
    DDI: 49,
    name: 'Minimum Count Per Time Application Rate',
    unit: '/s',
    bitResolution: 0.001,
  },
  '50': {
    DDI: 50,
    name: 'Maximum Count Per Time Application Rate',
    unit: '/s',
    bitResolution: 0.001,
  },
  '51': { DDI: 51, name: 'Setpoint Tillage Depth', unit: 'mm', bitResolution: 1 },
  '52': { DDI: 52, name: 'Actual Tillage Depth', unit: 'mm', bitResolution: 1 },
  '53': { DDI: 53, name: 'Default Tillage Depth', unit: 'mm', bitResolution: 1 },
  '54': { DDI: 54, name: 'Minimum Tillage Depth', unit: 'mm', bitResolution: 1 },
  '55': { DDI: 55, name: 'Maximum Tillage Depth', unit: 'mm', bitResolution: 1 },
  '56': { DDI: 56, name: 'Setpoint Seeding Depth', unit: 'mm', bitResolution: 1 },
  '57': { DDI: 57, name: 'Actual Seeding Depth', unit: 'mm', bitResolution: 1 },
  '58': { DDI: 58, name: 'Default Seeding Depth', unit: 'mm', bitResolution: 1 },
  '59': { DDI: 59, name: 'Minimum Seeding Depth', unit: 'mm', bitResolution: 1 },
  '60': { DDI: 60, name: 'Maximum Seeding Depth', unit: 'mm', bitResolution: 1 },
  '61': { DDI: 61, name: 'Setpoint Working Height', unit: 'mm', bitResolution: 1 },
  '62': { DDI: 62, name: 'Actual Working Height', unit: 'mm', bitResolution: 1 },
  '63': { DDI: 63, name: 'Default Working Height', unit: 'mm', bitResolution: 1 },
  '64': { DDI: 64, name: 'Minimum Working Height', unit: 'mm', bitResolution: 1 },
  '65': { DDI: 65, name: 'Maximum Working Height', unit: 'mm', bitResolution: 1 },
  '66': { DDI: 66, name: 'Setpoint Working Width', unit: 'mm', bitResolution: 1 },
  '67': { DDI: 67, name: 'Actual Working Width', unit: 'mm', bitResolution: 1 },
  '68': { DDI: 68, name: 'Default Working Width', unit: 'mm', bitResolution: 1 },
  '69': { DDI: 69, name: 'Minimum Working Width', unit: 'mm', bitResolution: 1 },
  '70': { DDI: 70, name: 'Maximum Working Width', unit: 'mm', bitResolution: 1 },
  '71': { DDI: 71, name: 'Setpoint Volume Content', unit: 'ml', bitResolution: 1 },
  '72': { DDI: 72, name: 'Actual Volume Content', unit: 'ml', bitResolution: 1 },
  '73': { DDI: 73, name: 'Maximum Volume Content', unit: 'ml', bitResolution: 1 },
  '74': { DDI: 74, name: 'Setpoint Mass Content', unit: 'g', bitResolution: 1 },
  '75': { DDI: 75, name: 'Actual Mass Content', unit: 'g', bitResolution: 1 },
  '76': { DDI: 76, name: 'Maximum Mass Content', unit: 'g', bitResolution: 1 },
  '77': { DDI: 77, name: 'Setpoint Count Content', unit: '#', bitResolution: 1 },
  '78': { DDI: 78, name: 'Actual Count Content', unit: '#', bitResolution: 1 },
  '79': { DDI: 79, name: 'Maximum Count Content', unit: '#', bitResolution: 1 },
  '80': { DDI: 80, name: 'Application Total Volume as [L]', unit: 'L', bitResolution: 1 },
  '81': { DDI: 81, name: 'Application Total Mass in [kg]', unit: 'kg', bitResolution: 1 },
  '82': { DDI: 82, name: 'Application Total Count', unit: '#', bitResolution: 1 },
  '83': { DDI: 83, name: 'Volume Per Area Yield', unit: 'ml/m²', bitResolution: 1 },
  '84': { DDI: 84, name: 'Mass Per Area Yield', unit: 'mg/m²', bitResolution: 1 },
  '85': { DDI: 85, name: 'Count Per Area Yield', unit: '/m²', bitResolution: 0.001 },
  '86': { DDI: 86, name: 'Volume Per Time Yield', unit: 'ml/s', bitResolution: 1 },
  '87': { DDI: 87, name: 'Mass Per Time Yield', unit: 'mg/s', bitResolution: 1 },
  '88': { DDI: 88, name: 'Count Per Time Yield', unit: '/s', bitResolution: 0.001 },
  '89': { DDI: 89, name: 'Yield Total Volume', unit: 'L', bitResolution: 1 },
  '90': { DDI: 90, name: 'Yield Total Mass', unit: 'kg', bitResolution: 1 },
  '91': { DDI: 91, name: 'Yield Total Count', unit: '#', bitResolution: 1 },
  '92': { DDI: 92, name: 'Volume Per Area Crop Loss', unit: 'ml/m²', bitResolution: 1 },
  '93': { DDI: 93, name: 'Mass Per Area Crop Loss', unit: 'mg/m²', bitResolution: 1 },
  '94': { DDI: 94, name: 'Count Per Area Crop Loss', unit: '/m²', bitResolution: 0.001 },
  '95': { DDI: 95, name: 'Volume Per Time Crop Loss', unit: 'ml/s', bitResolution: 1 },
  '96': { DDI: 96, name: 'Mass Per Time Crop Loss', unit: 'mg/s', bitResolution: 1 },
  '97': { DDI: 97, name: 'Count Per Time Crop Loss', unit: '/s', bitResolution: 0.001 },
  '98': { DDI: 98, name: 'Percentage Crop Loss', unit: 'ppm', bitResolution: 1 },
  '99': { DDI: 99, name: 'Crop Moisture', unit: 'ppm', bitResolution: 1 },
  '100': { DDI: 100, name: 'Crop Contamination', unit: 'ppm', bitResolution: 1 },
  '101': { DDI: 101, name: 'Setpoint Bale Width', unit: 'mm', bitResolution: 1 },
  '102': { DDI: 102, name: 'Actual Bale Width', unit: 'mm', bitResolution: 1 },
  '103': { DDI: 103, name: 'Default Bale Width', unit: 'mm', bitResolution: 1 },
  '104': { DDI: 104, name: 'Minimum Bale Width', unit: 'mm', bitResolution: 1 },
  '105': { DDI: 105, name: 'Maximum Bale Width', unit: 'mm', bitResolution: 1 },
  '106': { DDI: 106, name: 'Setpoint Bale Height', unit: 'mm', bitResolution: 1 },
  '107': { DDI: 107, name: 'ActualBaleHeight', unit: 'mm', bitResolution: 1 },
  '108': { DDI: 108, name: 'Default Bale Height', unit: 'mm', bitResolution: 1 },
  '109': { DDI: 109, name: 'Minimum Bale Height', unit: 'mm', bitResolution: 1 },
  '110': { DDI: 110, name: 'Maximum Bale Height', unit: 'mm', bitResolution: 1 },
  '111': { DDI: 111, name: 'Setpoint Bale Size', unit: 'mm', bitResolution: 1 },
  '112': { DDI: 112, name: 'Actual Bale Size', unit: 'mm', bitResolution: 1 },
  '113': { DDI: 113, name: 'Default Bale Size', unit: 'mm', bitResolution: 1 },
  '114': { DDI: 114, name: 'Minimum Bale Size', unit: 'mm', bitResolution: 1 },
  '115': { DDI: 115, name: 'Maximum Bale Size', unit: 'mm', bitResolution: 1 },
  '116': { DDI: 116, name: 'Total Area', unit: 'm²', bitResolution: 1 },
  '117': { DDI: 117, name: 'Effective Total Distance', unit: 'mm', bitResolution: 1 },
  '118': { DDI: 118, name: 'Ineffective Total Distance', unit: 'mm', bitResolution: 1 },
  '119': { DDI: 119, name: 'Effective Total Time', unit: 's', bitResolution: 1 },
  '120': { DDI: 120, name: 'Ineffective Total Time', unit: 's', bitResolution: 1 },
  '121': { DDI: 121, name: 'Product Density Mass Per Volume', unit: 'mg/l', bitResolution: 1 },
  '122': { DDI: 122, name: 'Product Density Mass PerCount', unit: 'mg/1000', bitResolution: 1 },
  '123': { DDI: 123, name: 'Product Density Volume Per Count', unit: 'ml/1000', bitResolution: 1 },
  '124': { DDI: 124, name: 'Auxiliary Valve Scaling Extend', unit: '0.00%', bitResolution: 0.1 },
  '125': { DDI: 125, name: 'Auxiliary Valve Scaling Retract', unit: '0.00%', bitResolution: 0.1 },
  '126': { DDI: 126, name: 'Auxiliary Valve Ramp Extend Up', unit: 'ms', bitResolution: 1 },
  '127': { DDI: 127, name: 'Auxiliary Valve Ramp Extend Down', unit: 'ms', bitResolution: 1 },
  '128': { DDI: 128, name: 'Auxiliary Valve Ramp Retract Up', unit: 'ms', bitResolution: 1 },
  '129': { DDI: 129, name: 'Auxiliary Valve Ramp Retract Down', unit: 'ms', bitResolution: 1 },
  '130': { DDI: 130, name: 'Auxiliary Valve Float Threshold', unit: '0.00%', bitResolution: 0.1 },
  '131': { DDI: 131, name: 'Auxiliary Valve Progressivity Extend', unit: 'n.a.', bitResolution: 1 },
  '132': {
    DDI: 132,
    name: 'Auxiliary Valve Progressivity Retract',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '133': { DDI: 133, name: 'Auxiliary Valve Invert Ports', unit: 'n.a.', bitResolution: 1 },
  '134': { DDI: 134, name: 'Device Element Offset X', unit: 'mm', bitResolution: 1 },
  '135': { DDI: 135, name: 'Device Element Offset Y', unit: 'mm', bitResolution: 1 },
  '136': { DDI: 136, name: 'Device Element Offset Z', unit: 'mm', bitResolution: 1 },
  '137': { DDI: 137, name: 'Device Volume Capacity', unit: 'ml', bitResolution: 1 },
  '138': { DDI: 138, name: 'Device Mass Capacity', unit: 'g', bitResolution: 1 },
  '139': { DDI: 139, name: 'Device Count Capacity', unit: '#', bitResolution: 1 },
  '140': { DDI: 140, name: 'Setpoint Percentage Application Rate', unit: 'ppm', bitResolution: 1 },
  '141': { DDI: 141, name: 'Actual Work State', unit: 'n.a.', bitResolution: 1 },
  '142': { DDI: 142, name: 'Physical Setpoint Time Latency', unit: 'ms', bitResolution: 1 },
  '143': { DDI: 143, name: 'Physical Actual Value Time Latency', unit: 'ms', bitResolution: 1 },
  '144': { DDI: 144, name: 'Yaw Angle', unit: '°', bitResolution: 0.001 },
  '145': { DDI: 145, name: 'Roll Angle', unit: '°', bitResolution: 0.001 },
  '146': { DDI: 146, name: 'Pitch Angle', unit: '°', bitResolution: 0.001 },
  '147': { DDI: 147, name: 'Log Count', unit: 'n.a.', bitResolution: 1 },
  '148': { DDI: 148, name: 'Total Fuel Consumption', unit: 'ml', bitResolution: 1 },
  '149': {
    DDI: 149,
    name: 'Instantaneous Fuel Consumption per Time',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '150': {
    DDI: 150,
    name: 'Instantaneous Fuel Consumption per Area',
    unit: 'mm³/m²',
    bitResolution: 1,
  },
  '151': {
    DDI: 151,
    name: 'Instantaneous Area Per Time Capacity',
    unit: 'mm²/s',
    bitResolution: 1,
  },
  '153': {
    DDI: 153,
    name: 'Actual Normalized Difference Vegetative Index (NDVI)',
    unit: 'n.a.',
    bitResolution: 0.001,
  },
  '154': { DDI: 154, name: 'Physical Object Length', unit: 'mm', bitResolution: 1 },
  '155': { DDI: 155, name: 'Physical Object Width', unit: 'mm', bitResolution: 1 },
  '156': { DDI: 156, name: 'Physical Object Height', unit: 'mm', bitResolution: 1 },
  '157': { DDI: 157, name: 'Connector Type', unit: 'n.a.', bitResolution: 1 },
  '158': { DDI: 158, name: 'Prescription Control State', unit: 'n.a.', bitResolution: 1 },
  '159': { DDI: 159, name: 'Number of Sub-Units per Section', unit: '#', bitResolution: 1 },
  '160': { DDI: 160, name: 'Section Control State', unit: 'n.a.', bitResolution: 1 },
  '161': { DDI: 161, name: 'Actual Condensed Work State (1-16)', unit: 'n.a.', bitResolution: 1 },
  '162': { DDI: 162, name: 'Actual Condensed Work State (17-32)', unit: 'n.a.', bitResolution: 1 },
  '163': { DDI: 163, name: 'Actual Condensed Work State (33-48)', unit: 'n.a.', bitResolution: 1 },
  '164': { DDI: 164, name: 'Actual Condensed Work State (49-64)', unit: 'n.a.', bitResolution: 1 },
  '165': { DDI: 165, name: 'Actual Condensed Work State (65-80)', unit: 'n.a.', bitResolution: 1 },
  '166': { DDI: 166, name: 'Actual Condensed Work State (81-96)', unit: 'n.a.', bitResolution: 1 },
  '167': { DDI: 167, name: 'Actual Condensed Work State (97-112)', unit: 'n.a.', bitResolution: 1 },
  '168': {
    DDI: 168,
    name: 'Actual Condensed Work State (113-128)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '169': {
    DDI: 169,
    name: 'Actual Condensed Work State (129-144)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '170': {
    DDI: 170,
    name: 'Actual Condensed Work State (145-160)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '171': {
    DDI: 171,
    name: 'Actual Condensed Work State (161-176)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '172': {
    DDI: 172,
    name: 'Actual Condensed Work State (177-192)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '173': {
    DDI: 173,
    name: 'Actual Condensed Work State (193-208)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '174': {
    DDI: 174,
    name: 'Actual Condensed Work State (209-224)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '175': {
    DDI: 175,
    name: 'Actual Condensed Work State (225-240)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '176': {
    DDI: 176,
    name: 'Actual Condensed Work State (241-256)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '177': { DDI: 177, name: 'Actual length of cut', unit: 'mm', bitResolution: 0.001 },
  '178': { DDI: 178, name: 'Element Type Instance', unit: 'n.a.', bitResolution: 1 },
  '179': { DDI: 179, name: 'Actual Cultural Practice', unit: 'n.a.', bitResolution: 1 },
  '180': {
    DDI: 180,
    name: 'Device Reference Point (DRP) to Ground distance',
    unit: 'mm',
    bitResolution: 1,
  },
  '181': { DDI: 181, name: 'Dry Mass Per Area Yield', unit: 'mg/m²', bitResolution: 1 },
  '182': { DDI: 182, name: 'Dry Mass Per Time Yield', unit: 'mg/s', bitResolution: 1 },
  '183': { DDI: 183, name: 'Yield Total Dry Mass', unit: 'kg', bitResolution: 1 },
  '184': { DDI: 184, name: 'Reference Moisture For Dry Mass', unit: 'ppm', bitResolution: 1 },
  '185': { DDI: 185, name: 'Seed Cotton Mass Per Area Yield', unit: 'mg/m²', bitResolution: 1 },
  '186': { DDI: 186, name: 'Lint Cotton Mass Per Area Yield', unit: 'mg/m²', bitResolution: 1 },
  '187': { DDI: 187, name: 'Seed Cotton Mass Per Time Yield', unit: 'mg/s', bitResolution: 1 },
  '188': { DDI: 188, name: 'Lint Cotton Mass Per Time Yield', unit: 'mg/s', bitResolution: 1 },
  '189': { DDI: 189, name: 'Yield Total Seed Cotton Mass', unit: 'kg', bitResolution: 1 },
  '190': { DDI: 190, name: 'Yield Total Lint Cotton Mass', unit: 'kg', bitResolution: 1 },
  '191': { DDI: 191, name: 'Lint Turnout Percentage ', unit: 'ppm', bitResolution: 1 },
  '192': { DDI: 192, name: 'Ambient temperature', unit: 'mK', bitResolution: 1 },
  '193': { DDI: 193, name: 'Setpoint Product Pressure', unit: 'Pa', bitResolution: 0.1 },
  '194': { DDI: 194, name: 'Actual Product Pressure', unit: 'Pa', bitResolution: 0.1 },
  '195': { DDI: 195, name: 'Minimum Product Pressure', unit: 'Pa', bitResolution: 0.1 },
  '196': { DDI: 196, name: 'Maximum Product Pressure', unit: 'Pa', bitResolution: 0.1 },
  '197': { DDI: 197, name: 'Setpoint Pump Output Pressure', unit: 'Pa', bitResolution: 0.1 },
  '198': { DDI: 198, name: 'Actual Pump Output Pressure', unit: 'Pa', bitResolution: 0.1 },
  '199': { DDI: 199, name: 'Minimum Pump Output Pressure', unit: 'Pa', bitResolution: 0.1 },
  '200': { DDI: 200, name: 'Maximum Pump Output Pressure', unit: 'Pa', bitResolution: 0.1 },
  '201': { DDI: 201, name: 'Setpoint Tank Agitation Pressure', unit: 'Pa', bitResolution: 0.1 },
  '202': { DDI: 202, name: 'Actual Tank Agitation Pressure', unit: 'Pa', bitResolution: 0.1 },
  '203': { DDI: 203, name: 'Minimum Tank Agitation Pressure', unit: 'Pa', bitResolution: 0.1 },
  '204': { DDI: 204, name: 'Maximum Tank Agitation Pressure', unit: 'Pa', bitResolution: 0.1 },
  '205': { DDI: 205, name: 'SC Turn On Time', unit: 'ms', bitResolution: 1 },
  '206': { DDI: 206, name: 'SC Turn Off Time', unit: 'ms', bitResolution: 1 },
  '207': { DDI: 207, name: 'Wind speed', unit: 'mm/s', bitResolution: 1 },
  '208': { DDI: 208, name: 'Wind direction', unit: '°', bitResolution: 1 },
  '209': { DDI: 209, name: 'Relative Humidity', unit: '0.00%', bitResolution: 1 },
  '210': { DDI: 210, name: 'Sky conditions', unit: 'n.a.', bitResolution: 1 },
  '211': { DDI: 211, name: 'Last Bale Flakes per Bale', unit: '#', bitResolution: 1 },
  '212': { DDI: 212, name: 'Last Bale Average Moisture', unit: 'ppm', bitResolution: 1 },
  '213': { DDI: 213, name: 'Last Bale Average Strokes per Flake', unit: '#', bitResolution: 1 },
  '214': { DDI: 214, name: 'Lifetime Bale Count', unit: '#', bitResolution: 1 },
  '215': { DDI: 215, name: 'Lifetime Working Hours', unit: 'h', bitResolution: 0.05 },
  '216': { DDI: 216, name: 'Actual Bale Hydraulic Pressure', unit: 'Pa', bitResolution: 1 },
  '217': { DDI: 217, name: 'Last Bale Average Hydraulic Pressure', unit: 'Pa', bitResolution: 1 },
  '218': {
    DDI: 218,
    name: 'Setpoint Bale Compression Plunger Load',
    unit: 'ppm',
    bitResolution: 1,
  },
  '219': { DDI: 219, name: 'Actual Bale Compression Plunger Load', unit: 'ppm', bitResolution: 1 },
  '220': {
    DDI: 220,
    name: 'Last Bale Average Bale Compression Plunger Load',
    unit: 'ppm',
    bitResolution: 1,
  },
  '221': { DDI: 221, name: 'Last Bale Applied Preservative', unit: 'ml', bitResolution: 1 },
  '222': { DDI: 222, name: 'Last Bale Tag Number', unit: 'n.a.', bitResolution: 1 },
  '223': { DDI: 223, name: 'Last Bale Mass', unit: 'g', bitResolution: 1 },
  '224': { DDI: 224, name: 'Delta T', unit: 'mK', bitResolution: 1 },
  '225': { DDI: 225, name: 'Setpoint Working Length', unit: 'mm', bitResolution: 1 },
  '226': { DDI: 226, name: 'Actual Working Length', unit: 'mm', bitResolution: 1 },
  '227': { DDI: 227, name: 'Minimum Working Length', unit: 'mm', bitResolution: 1 },
  '228': { DDI: 228, name: 'Maximum Working Length', unit: 'mm', bitResolution: 1 },
  '229': { DDI: 229, name: 'Actual Net Weight', unit: 'g', bitResolution: 1 },
  '230': { DDI: 230, name: 'Net Weight State', unit: 'n.a.', bitResolution: 1 },
  '231': { DDI: 231, name: 'Setpoint Net Weight', unit: 'g', bitResolution: 1 },
  '232': { DDI: 232, name: 'Actual Gross Weight', unit: 'g', bitResolution: 1 },
  '233': { DDI: 233, name: 'Gross Weight State', unit: 'n.a.', bitResolution: 1 },
  '234': { DDI: 234, name: 'Minimum Gross Weight', unit: 'g', bitResolution: 1 },
  '235': { DDI: 235, name: 'Maximum Gross Weight', unit: 'g', bitResolution: 1 },
  '236': { DDI: 236, name: 'Thresher Engagement Total Time', unit: 's', bitResolution: 1 },
  '237': { DDI: 237, name: 'Actual Header Working Height Status', unit: 'n.a.', bitResolution: 1 },
  '238': {
    DDI: 238,
    name: 'Actual Header Rotational Speed Status',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '239': { DDI: 239, name: 'Yield Hold Status', unit: 'n.a.', bitResolution: 1 },
  '240': { DDI: 240, name: 'Actual (Un)Loading System Status', unit: 'n.a.', bitResolution: 1 },
  '241': { DDI: 241, name: 'Crop Temperature', unit: 'mK', bitResolution: 1 },
  '242': { DDI: 242, name: 'Setpoint Sieve Clearance', unit: 'mm', bitResolution: 1 },
  '243': { DDI: 243, name: 'Actual Sieve Clearance', unit: 'mm', bitResolution: 1 },
  '244': { DDI: 244, name: 'Minimum Sieve Clearance', unit: 'mm', bitResolution: 1 },
  '245': { DDI: 245, name: 'Maximum Sieve Clearance', unit: 'mm', bitResolution: 1 },
  '246': { DDI: 246, name: 'Setpoint Chaffer Clearance', unit: 'mm', bitResolution: 1 },
  '247': { DDI: 247, name: 'Actual Chaffer Clearance', unit: 'mm', bitResolution: 1 },
  '248': { DDI: 248, name: 'Minimum Chaffer Clearance', unit: 'mm', bitResolution: 1 },
  '249': { DDI: 249, name: 'Maximum Chaffer Clearance', unit: 'mm', bitResolution: 1 },
  '250': { DDI: 250, name: 'Setpoint Concave Clearance', unit: 'mm', bitResolution: 1 },
  '251': { DDI: 251, name: 'Actual Concave Clearance', unit: 'mm', bitResolution: 1 },
  '252': { DDI: 252, name: 'Minimum Concave Clearance', unit: 'mm', bitResolution: 1 },
  '253': { DDI: 253, name: 'Maximum Concave Clearance', unit: 'mm', bitResolution: 1 },
  '254': {
    DDI: 254,
    name: 'Setpoint Separation Fan Rotational Speed',
    unit: '/s',
    bitResolution: 0.001,
  },
  '255': {
    DDI: 255,
    name: 'Actual Separation Fan Rotational Speed',
    unit: '/s',
    bitResolution: 0.001,
  },
  '256': {
    DDI: 256,
    name: 'Minimum Separation Fan Rotational Speed',
    unit: '/s',
    bitResolution: 0.001,
  },
  '257': {
    DDI: 257,
    name: 'Maximum Separation Fan Rotational Speed',
    unit: '/s',
    bitResolution: 0.001,
  },
  '258': { DDI: 258, name: 'Hydraulic Oil Temperature', unit: 'mK', bitResolution: 1 },
  '259': { DDI: 259, name: 'Yield Lag Ignore Time', unit: 'ms', bitResolution: 1 },
  '260': { DDI: 260, name: 'Yield Lead Ignore Time', unit: 'ms', bitResolution: 1 },
  '261': { DDI: 261, name: 'Average Yield Mass Per Time', unit: 'mg/s', bitResolution: 1 },
  '262': { DDI: 262, name: 'Average Crop Moisture', unit: 'ppm', bitResolution: 1 },
  '263': { DDI: 263, name: 'Average Yield Mass Per Area', unit: 'mg/m²', bitResolution: 1 },
  '264': { DDI: 264, name: 'Connector Pivot X-Offset', unit: 'mm', bitResolution: 1 },
  '265': { DDI: 265, name: 'Remaining Area', unit: 'm²', bitResolution: 1 },
  '266': { DDI: 266, name: 'Lifetime Application Total Mass', unit: 'kg', bitResolution: 1 },
  '267': { DDI: 267, name: 'Lifetime Application Total Count', unit: '#', bitResolution: 1 },
  '268': { DDI: 268, name: 'Lifetime Yield Total Volume', unit: 'L', bitResolution: 1 },
  '269': { DDI: 269, name: 'Lifetime Yield Total Mass', unit: 'kg', bitResolution: 1 },
  '270': { DDI: 270, name: 'Lifetime Yield Total Count', unit: '#', bitResolution: 1 },
  '271': { DDI: 271, name: 'Lifetime Total Area', unit: 'm²', bitResolution: 1 },
  '272': { DDI: 272, name: 'Lifetime Effective Total Distance', unit: 'm', bitResolution: 1 },
  '273': { DDI: 273, name: 'Lifetime Ineffective Total Distance', unit: 'm', bitResolution: 1 },
  '274': { DDI: 274, name: 'Lifetime Effective Total Time', unit: 's', bitResolution: 1 },
  '275': { DDI: 275, name: 'Lifetime Ineffective Total Time', unit: 's', bitResolution: 1 },
  '276': { DDI: 276, name: 'Lifetime Fuel Consumption', unit: 'L', bitResolution: 0.5 },
  '277': {
    DDI: 277,
    name: 'Lifetime Average Fuel Consumption per Time',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '278': {
    DDI: 278,
    name: 'Lifetime Average Fuel Consumption per Area',
    unit: 'mm³/m²',
    bitResolution: 1,
  },
  '279': { DDI: 279, name: 'Lifetime Yield Total Dry Mass', unit: 'kg', bitResolution: 1 },
  '280': { DDI: 280, name: 'Lifetime Yield Total Seed Cotton Mass', unit: 'kg', bitResolution: 1 },
  '281': { DDI: 281, name: 'Lifetime Yield Total Lint Cotton Mass', unit: 'kg', bitResolution: 1 },
  '282': {
    DDI: 282,
    name: 'Lifetime Threshing Engagement Total Time',
    unit: 's',
    bitResolution: 1,
  },
  '283': { DDI: 283, name: 'Precut Total Count', unit: '#', bitResolution: 1 },
  '284': { DDI: 284, name: 'Uncut Total Count', unit: '#', bitResolution: 1 },
  '285': { DDI: 285, name: 'Lifetime Precut Total Count', unit: '#', bitResolution: 1 },
  '286': { DDI: 286, name: 'Lifetime Uncut Total Count', unit: '#', bitResolution: 1 },
  '287': { DDI: 287, name: 'Setpoint Prescription Mode', unit: 'n.a.', bitResolution: 1 },
  '288': { DDI: 288, name: 'Actual Prescription Mode', unit: 'n.a.', bitResolution: 1 },
  '289': { DDI: 289, name: 'Setpoint Work State', unit: 'n.a.', bitResolution: 1 },
  '290': { DDI: 290, name: 'Setpoint Condensed Work State (1-16)', unit: 'n.a.', bitResolution: 1 },
  '291': {
    DDI: 291,
    name: 'Setpoint Condensed Work State (17-32)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '292': {
    DDI: 292,
    name: 'Setpoint Condensed Work State (33-48)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '293': {
    DDI: 293,
    name: 'Setpoint Condensed Work State (49-64)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '294': {
    DDI: 294,
    name: 'Setpoint Condensed Work State (65-80)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '295': {
    DDI: 295,
    name: 'Setpoint Condensed Work State (81-96)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '296': {
    DDI: 296,
    name: 'Setpoint Condensed Work State (97-112)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '297': {
    DDI: 297,
    name: 'Setpoint Condensed Work State (113-128)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '298': {
    DDI: 298,
    name: 'Setpoint Condensed Work State (129-144)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '299': {
    DDI: 299,
    name: 'Setpoint Condensed Work State (145-160)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '300': {
    DDI: 300,
    name: 'Setpoint Condensed Work State (161-176)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '301': {
    DDI: 301,
    name: 'Setpoint Condensed Work State (177-192)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '302': {
    DDI: 302,
    name: 'Setpoint Condensed Work State (193-208)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '303': {
    DDI: 303,
    name: 'Setpoint Condensed Work State (209-224)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '304': {
    DDI: 304,
    name: 'Setpoint Condensed Work State (225-240)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '305': {
    DDI: 305,
    name: 'Setpoint Condensed Work State (241-256)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '306': { DDI: 306, name: 'True Rotation Point  X-Offset ', unit: 'mm', bitResolution: 1 },
  '307': { DDI: 307, name: 'True Rotation Point Y-Offset', unit: 'mm', bitResolution: 1 },
  '308': { DDI: 308, name: 'Actual Percentage Application Rate', unit: 'ppm', bitResolution: 1 },
  '309': { DDI: 309, name: 'Minimum Percentage Application Rate', unit: 'ppm', bitResolution: 1 },
  '310': { DDI: 310, name: 'Maximum Percentage Application Rate', unit: 'ppm', bitResolution: 1 },
  '311': { DDI: 311, name: 'Relative Yield Potential', unit: 'ppm', bitResolution: 1 },
  '312': { DDI: 312, name: 'Minimum Relative Yield Potential', unit: 'ppm', bitResolution: 1 },
  '313': { DDI: 313, name: 'Maximum Relative Yield Potential', unit: 'ppm', bitResolution: 1 },
  '314': { DDI: 314, name: 'Actual Percentage Crop Dry Matter', unit: 'ppm', bitResolution: 1 },
  '315': { DDI: 315, name: 'Average Percentage Crop Dry Matter ', unit: 'ppm', bitResolution: 1 },
  '316': { DDI: 316, name: 'Effective Total Fuel Consumption', unit: 'ml', bitResolution: 1 },
  '317': { DDI: 317, name: 'Ineffective Total Fuel Consumption', unit: 'ml', bitResolution: 1 },
  '318': {
    DDI: 318,
    name: 'Effective Total Diesel Exhaust Fluid Consumption',
    unit: 'ml',
    bitResolution: 1,
  },
  '319': {
    DDI: 319,
    name: 'Ineffective Total Diesel Exhaust Fluid Consumption',
    unit: 'ml',
    bitResolution: 1,
  },
  '320': { DDI: 320, name: 'Last loaded Weight', unit: 'g', bitResolution: 1 },
  '321': { DDI: 321, name: 'Last unloaded Weight', unit: 'g', bitResolution: 1 },
  '322': { DDI: 322, name: 'Load Identification Number', unit: '#', bitResolution: 1 },
  '323': { DDI: 323, name: 'Unload Identification Number', unit: '#', bitResolution: 1 },
  '324': { DDI: 324, name: 'Chopper Engagement Total Time', unit: 's', bitResolution: 1 },
  '325': { DDI: 325, name: 'Lifetime Application Total Volume', unit: 'L', bitResolution: 1 },
  '326': { DDI: 326, name: 'Setpoint Header Speed', unit: '/s', bitResolution: 0.001 },
  '327': { DDI: 327, name: 'Actual Header Speed', unit: '/s', bitResolution: 0.001 },
  '328': { DDI: 328, name: 'Minimum Header Speed', unit: '/s', bitResolution: 0.001 },
  '329': { DDI: 329, name: 'Maximum Header Speed', unit: '/s', bitResolution: 0.001 },
  '330': { DDI: 330, name: 'Setpoint Cutting drum speed', unit: '/s', bitResolution: 0.001 },
  '331': { DDI: 331, name: 'Actual Cutting drum speed', unit: '/s', bitResolution: 0.001 },
  '332': { DDI: 332, name: 'Minimum Cutting drum speed', unit: '/s', bitResolution: 0.001 },
  '333': { DDI: 333, name: 'Maximum Cutting drum speed', unit: '/s', bitResolution: 0.001 },
  '334': { DDI: 334, name: 'Operating Hours Since Last Sharpening', unit: 's', bitResolution: 1 },
  '335': { DDI: 335, name: 'Front PTO hours', unit: 's', bitResolution: 1 },
  '336': { DDI: 336, name: 'Rear PTO hours', unit: 's', bitResolution: 1 },
  '337': { DDI: 337, name: 'Lifetime Front PTO hours', unit: 'h', bitResolution: 0.1 },
  '338': { DDI: 338, name: 'Lifetime Rear PTO Hours', unit: 'h', bitResolution: 0.1 },
  '339': { DDI: 339, name: 'Effective Total Loading Time', unit: 's', bitResolution: 1 },
  '340': { DDI: 340, name: 'Effective Total Unloading Time', unit: 's', bitResolution: 1 },
  '341': { DDI: 341, name: 'Setpoint Grain Kernel Cracker Gap', unit: 'mm', bitResolution: 0.001 },
  '342': { DDI: 342, name: 'Actual Grain Kernel Cracker Gap', unit: 'mm', bitResolution: 0.001 },
  '343': { DDI: 343, name: 'Minimum Grain Kernel Cracker Gap', unit: 'mm', bitResolution: 0.001 },
  '344': { DDI: 344, name: 'Maximum Grain Kernel Cracker Gap', unit: 'mm', bitResolution: 0.001 },
  '345': { DDI: 345, name: 'Setpoint Swathing Width', unit: 'mm', bitResolution: 1 },
  '346': { DDI: 346, name: 'Actual Swathing Width', unit: 'mm', bitResolution: 1 },
  '347': { DDI: 347, name: 'Minimum Swathing Width', unit: 'mm', bitResolution: 1 },
  '348': { DDI: 348, name: 'Maximum Swathing Width', unit: 'mm', bitResolution: 1 },
  '349': { DDI: 349, name: 'Nozzle Drift Reduction', unit: 'ppm', bitResolution: 1 },
  '350': { DDI: 350, name: 'Function or Operation Technique', unit: 'n.a.', bitResolution: 1 },
  '351': { DDI: 351, name: 'Application Total Volume in [ml]', unit: 'ml', bitResolution: 1 },
  '352': { DDI: 352, name: 'Application Total Mass in gram [g]', unit: 'g', bitResolution: 1 },
  '353': { DDI: 353, name: 'Total Application of Nitrogen', unit: 'g', bitResolution: 1 },
  '354': { DDI: 354, name: 'Total Application of Ammonium', unit: 'g', bitResolution: 1 },
  '355': { DDI: 355, name: 'Total Application of Phosphor', unit: 'g', bitResolution: 1 },
  '356': { DDI: 356, name: 'Total Application of Potassium', unit: 'g', bitResolution: 1 },
  '357': { DDI: 357, name: 'Total Application of Dry Matter', unit: 'kg', bitResolution: 1 },
  '358': { DDI: 358, name: 'Average Dry Yield Mass Per Time', unit: 'mg/s', bitResolution: 1 },
  '359': { DDI: 359, name: 'Average Dry Yield Mass Per Area', unit: 'mg/m²', bitResolution: 1 },
  '360': { DDI: 360, name: 'Last Bale Size', unit: 'mm', bitResolution: 1 },
  '361': { DDI: 361, name: 'Last Bale Density', unit: 'mg/l', bitResolution: 1 },
  '362': { DDI: 362, name: 'Total Bale Length', unit: 'mm', bitResolution: 1 },
  '363': { DDI: 363, name: 'Last Bale Dry Mass', unit: 'g', bitResolution: 1 },
  '364': { DDI: 364, name: 'Actual Flake Size', unit: 'mm', bitResolution: 1 },
  '365': { DDI: 365, name: 'Setpoint Downforce Pressure', unit: 'Pa', bitResolution: 1 },
  '366': { DDI: 366, name: 'Actual Downforce Pressure', unit: 'Pa', bitResolution: 1 },
  '367': { DDI: 367, name: 'Condensed Section Override State (1-16)', unit: '', bitResolution: 1 },
  '368': {
    DDI: 368,
    name: 'Condensed Section Override State (17-32) ',
    unit: '',
    bitResolution: 1,
  },
  '369': {
    DDI: 369,
    name: 'Condensed Section Override State (33-48) ',
    unit: '',
    bitResolution: 1,
  },
  '370': {
    DDI: 370,
    name: 'Condensed Section Override State (49-64) ',
    unit: '',
    bitResolution: 1,
  },
  '371': {
    DDI: 371,
    name: 'Condensed Section Override State (65-80) ',
    unit: '',
    bitResolution: 1,
  },
  '372': {
    DDI: 372,
    name: 'Condensed Section Override State (81-96) ',
    unit: '',
    bitResolution: 1,
  },
  '373': {
    DDI: 373,
    name: 'Condensed Section Override State (97-112) ',
    unit: '',
    bitResolution: 1,
  },
  '374': {
    DDI: 374,
    name: 'Condensed Section Override State (113-128) ',
    unit: '',
    bitResolution: 1,
  },
  '375': {
    DDI: 375,
    name: 'Condensed Section Override State (129-144) ',
    unit: '',
    bitResolution: 1,
  },
  '376': {
    DDI: 376,
    name: 'Condensed Section Override State (145-160) ',
    unit: '',
    bitResolution: 1,
  },
  '377': {
    DDI: 377,
    name: 'Condensed Section Override State (161-176) ',
    unit: '',
    bitResolution: 1,
  },
  '378': {
    DDI: 378,
    name: 'Condensed Section Override State (177-192) ',
    unit: '',
    bitResolution: 1,
  },
  '379': {
    DDI: 379,
    name: 'Condensed Section Override State (193-208) ',
    unit: '',
    bitResolution: 1,
  },
  '380': {
    DDI: 380,
    name: 'Condensed Section Override State (209-224) ',
    unit: '',
    bitResolution: 1,
  },
  '381': {
    DDI: 381,
    name: 'Condensed Section Override State (225-240) ',
    unit: '',
    bitResolution: 1,
  },
  '382': {
    DDI: 382,
    name: 'Condensed Section Override State (241-256) ',
    unit: '',
    bitResolution: 1,
  },
  '383': { DDI: 383, name: 'Apparent Wind Direction', unit: '°', bitResolution: 1 },
  '384': { DDI: 384, name: 'Apparent Wind Speed', unit: 'mm/s', bitResolution: 1 },
  '385': { DDI: 385, name: 'MSL Atmospheric Pressure ', unit: 'Pa', bitResolution: 0.1 },
  '386': { DDI: 386, name: 'Actual Atmospheric Pressure', unit: 'Pa', bitResolution: 0.1 },
  '387': {
    DDI: 387,
    name: 'Total Revolutions in Fractional Revolutions',
    unit: '#',
    bitResolution: 0.0001,
  },
  '388': {
    DDI: 388,
    name: 'Total Revolutions in Complete Revolutions',
    unit: '#',
    bitResolution: 1,
  },
  '389': {
    DDI: 389,
    name: 'Setpoint Revolutions specified as count per time',
    unit: 'r/min',
    bitResolution: 0.0001,
  },
  '390': { DDI: 390, name: 'Actual Revolutions Per Time', unit: 'r/min', bitResolution: 0.0001 },
  '391': { DDI: 391, name: 'Default Revolutions Per Time', unit: 'r/min', bitResolution: 0.0001 },
  '392': { DDI: 392, name: 'Minimum Revolutions Per Time', unit: 'r/min', bitResolution: 0.0001 },
  '393': { DDI: 393, name: 'Maximum Revolutions Per Time', unit: 'r/min', bitResolution: 0.0001 },
  '394': { DDI: 394, name: 'Actual Fuel Tank Content', unit: 'ml', bitResolution: 1 },
  '395': {
    DDI: 395,
    name: 'Actual Diesel Exhaust Fluid Tank Content',
    unit: 'ml',
    bitResolution: 1,
  },
  '396': { DDI: 396, name: 'Setpoint Speed', unit: 'mm/s', bitResolution: 1 },
  '397': { DDI: 397, name: 'Actual Speed', unit: 'mm/s', bitResolution: 1 },
  '398': { DDI: 398, name: 'Minimum Speed', unit: 'mm/s', bitResolution: 1 },
  '399': { DDI: 399, name: 'Maximum Speed', unit: 'mm/s', bitResolution: 1 },
  '400': { DDI: 400, name: 'Speed Source', unit: 'n.a.', bitResolution: 1 },
  '401': {
    DDI: 401,
    name: 'Actual Application of Nitrogen as [mg/l]',
    unit: 'mg/l',
    bitResolution: 1,
  },
  '402': { DDI: 402, name: 'Actual application of Ammonium', unit: 'mg/l', bitResolution: 1 },
  '403': { DDI: 403, name: 'Actual application of Phosphor', unit: 'mg/l', bitResolution: 1 },
  '404': { DDI: 404, name: 'Actual application of Potassium', unit: 'mg/l', bitResolution: 1 },
  '405': { DDI: 405, name: 'Actual application of Dry Matter', unit: 'mg/l', bitResolution: 1 },
  '406': { DDI: 406, name: 'Actual Protein Content ', unit: 'ppm', bitResolution: 1 },
  '407': { DDI: 407, name: 'Average Protein Content', unit: 'ppm', bitResolution: 1 },
  '408': { DDI: 408, name: 'Average Crop Contamination', unit: 'ppm', bitResolution: 1 },
  '409': { DDI: 409, name: 'Total Diesel Exhaust Fluid Consumption', unit: 'ml', bitResolution: 1 },
  '410': {
    DDI: 410,
    name: 'Instantaneous Diesel Exhaust Fluid Consumption per Time',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '411': {
    DDI: 411,
    name: 'Instantaneous Diesel Exhaust Fluid Consumption per Area',
    unit: 'mm³/m²',
    bitResolution: 1,
  },
  '412': {
    DDI: 412,
    name: 'Lifetime Diesel Exhaust Fluid Consumption',
    unit: 'L',
    bitResolution: 0.5,
  },
  '413': {
    DDI: 413,
    name: 'Lifetime Average Diesel Exhaust Fluid Consumption per Time',
    unit: 'mm³/s',
    bitResolution: 1,
  },
  '414': {
    DDI: 414,
    name: 'Lifetime Average Diesel Exhaust Fluid Consumption per Area',
    unit: 'mm³/m²',
    bitResolution: 1,
  },
  '415': { DDI: 415, name: 'Actual Seed Singulation Percentage', unit: 'ppm', bitResolution: 1 },
  '416': { DDI: 416, name: 'Average Seed Singulation Percentage', unit: 'ppm', bitResolution: 1 },
  '417': { DDI: 417, name: 'Actual Seed Skip Percentage', unit: 'ppm', bitResolution: 1 },
  '418': { DDI: 418, name: 'Average Seed Skip Percentage', unit: 'ppm', bitResolution: 1 },
  '419': { DDI: 419, name: 'Actual Seed Multiple Percentage', unit: 'ppm', bitResolution: 1 },
  '420': { DDI: 420, name: 'Average Seed Multiple Percentage', unit: 'ppm', bitResolution: 1 },
  '421': { DDI: 421, name: 'Actual Seed Spacing Deviation', unit: 'mm', bitResolution: 1 },
  '422': { DDI: 422, name: 'Average Seed Spacing Deviation', unit: 'mm', bitResolution: 1 },
  '423': {
    DDI: 423,
    name: 'Actual Coefficient of Variation of Seed Spacing Percentage ',
    unit: 'ppm',
    bitResolution: 1,
  },
  '424': {
    DDI: 424,
    name: 'Average Coefficient of Variation of Seed Spacing Percentage',
    unit: 'ppm',
    bitResolution: 1,
  },
  '425': {
    DDI: 425,
    name: 'Setpoint Maximum Allowed Seed Spacing Deviation',
    unit: 'mm',
    bitResolution: 1,
  },
  '426': { DDI: 426, name: 'Setpoint Downforce as Force', unit: 'N', bitResolution: 1 },
  '427': { DDI: 427, name: 'Actual Downforce as Force', unit: 'N', bitResolution: 1 },
  '428': { DDI: 428, name: 'Loaded Total Mass', unit: 'kg', bitResolution: 1 },
  '429': { DDI: 429, name: 'Unloaded Total Mass', unit: 'kg', bitResolution: 1 },
  '430': { DDI: 430, name: 'Lifetime Loaded Total Mass', unit: 'kg', bitResolution: 1 },
  '431': { DDI: 431, name: 'Lifetime Unloaded Total Mass', unit: 'kg', bitResolution: 1 },
  '432': {
    DDI: 432,
    name: 'Setpoint Application Rate of Nitrogen',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '433': {
    DDI: 433,
    name: 'Actual  Application Rate of Nitrogen',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '434': {
    DDI: 434,
    name: 'Minimum Application Rate of Nitrogen',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '435': {
    DDI: 435,
    name: 'Maximum  Application Rate of Nitrogen',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '436': {
    DDI: 436,
    name: 'Setpoint  Application Rate of Ammonium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '437': {
    DDI: 437,
    name: 'Actual  Application Rate of Ammonium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '438': {
    DDI: 438,
    name: 'Minimum  Application Rate of Ammonium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '439': {
    DDI: 439,
    name: 'Maximum  Application Rate of Ammonium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '440': {
    DDI: 440,
    name: 'Setpoint  Application Rate of Phosphor',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '441': {
    DDI: 441,
    name: 'Actual  Application Rate of Phosphor',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '442': {
    DDI: 442,
    name: 'Minimum  Application Rate of Phosphor',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '443': {
    DDI: 443,
    name: 'Maximum  Application Rate of Phosphor',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '444': {
    DDI: 444,
    name: 'Setpoint  Application Rate of Potassium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '445': {
    DDI: 445,
    name: 'Actual  Application Rate of Potassium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '446': {
    DDI: 446,
    name: 'Minimum Application Rate of Potassium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '447': {
    DDI: 447,
    name: 'Maximum Application Rate of Potassium',
    unit: 'mg/m²',
    bitResolution: 1,
  },
  '448': {
    DDI: 448,
    name: 'Setpoint Application Rate of Dry Matter',
    unit: 'ppm',
    bitResolution: 1,
  },
  '449': {
    DDI: 449,
    name: 'Actual  Application Rate of Dry Matter',
    unit: 'ppm',
    bitResolution: 1,
  },
  '450': {
    DDI: 450,
    name: 'Minimum Application Rate of Dry Matter',
    unit: 'ppm',
    bitResolution: 1,
  },
  '451': {
    DDI: 451,
    name: 'Maximum Application Rate of Dry Matter',
    unit: 'ppm',
    bitResolution: 1,
  },
  '452': { DDI: 452, name: 'Loaded Total Volume', unit: 'ml', bitResolution: 1 },
  '453': { DDI: 453, name: 'Unloaded Total Volume', unit: 'ml', bitResolution: 1 },
  '454': { DDI: 454, name: 'Lifetime loaded Total Volume', unit: 'L', bitResolution: 1 },
  '455': { DDI: 455, name: 'Lifetime Unloaded Total Volume', unit: 'L', bitResolution: 1 },
  '456': { DDI: 456, name: 'Last loaded Volume', unit: 'ml', bitResolution: 1 },
  '457': { DDI: 457, name: 'Last unloaded Volume', unit: 'ml', bitResolution: 1 },
  '458': { DDI: 458, name: 'Loaded Total Count', unit: '#', bitResolution: 1 },
  '459': { DDI: 459, name: 'Unloaded Total Count', unit: '#', bitResolution: 1 },
  '460': { DDI: 460, name: 'Lifetime Loaded Total Count', unit: '#', bitResolution: 1 },
  '461': { DDI: 461, name: 'Lifetime Unloaded Total Count', unit: '#', bitResolution: 1 },
  '462': { DDI: 462, name: 'Last loaded Count', unit: '#', bitResolution: 1 },
  '463': { DDI: 463, name: 'Last unloaded Count', unit: '#', bitResolution: 1 },
  '464': { DDI: 464, name: 'Haul Counter', unit: '#', bitResolution: 1 },
  '465': { DDI: 465, name: 'Lifetime Haul Counter', unit: '#', bitResolution: 1 },
  '466': { DDI: 466, name: 'Actual relative connector angle', unit: '°', bitResolution: 0.001 },
  '467': { DDI: 467, name: 'Actual Percentage Content', unit: '0.00%', bitResolution: 0.01 },
  '468': { DDI: 468, name: 'Soil Snow/Frozen Condtion', unit: 'n.a.', bitResolution: 1 },
  '469': { DDI: 469, name: 'Estimated Soil Water Condtion', unit: 'n.a.', bitResolution: 1 },
  '470': { DDI: 470, name: 'Soil Compaction', unit: 'n.a.', bitResolution: 1 },
  '472': { DDI: 472, name: 'Setpoint Length of Cut', unit: 'mm', bitResolution: 0.001 },
  '473': { DDI: 473, name: 'Minimum length of cut', unit: 'mm', bitResolution: 0.001 },
  '474': { DDI: 474, name: 'Maximum Length of Cut', unit: 'mm', bitResolution: 0.001 },
  '475': { DDI: 475, name: 'Setpoint Bale Hydraulic Pressure', unit: 'Pa', bitResolution: 1 },
  '476': { DDI: 476, name: 'Minimum Bale Hydraulic Pressure', unit: 'Pa', bitResolution: 1 },
  '477': { DDI: 477, name: 'Maximum Bale Hydraulic Pressure', unit: 'Pa', bitResolution: 1 },
  '478': { DDI: 478, name: 'Setpoint Flake Size', unit: 'mm', bitResolution: 1 },
  '479': { DDI: 479, name: 'Minimum Flake Size', unit: 'mm', bitResolution: 1 },
  '480': { DDI: 480, name: 'Maximum Flake Size', unit: 'mm', bitResolution: 1 },
  '481': { DDI: 481, name: 'Setpoint Number of Subbales', unit: '', bitResolution: 1 },
  '482': { DDI: 482, name: 'Last Bale Number of Subbales', unit: '', bitResolution: 1 },
  '483': { DDI: 483, name: 'Setpoint Engine Speed', unit: 'r/min', bitResolution: 0.0001 },
  '484': { DDI: 484, name: 'Actual Engine Speed', unit: 'r/min', bitResolution: 0.0001 },
  '485': { DDI: 485, name: 'Minimum Engine Speed', unit: 'r/min', bitResolution: 0.0001 },
  '486': { DDI: 486, name: 'Maximum Engine Speed', unit: 'r/min', bitResolution: 0.0001 },
  '488': {
    DDI: 488,
    name: 'Diesel Exhaust Fluid Tank Percentage Level',
    unit: '0.00%',
    bitResolution: 0.01,
  },
  '489': {
    DDI: 489,
    name: 'Maximum Diesel Exhaust Fluid Tank Content',
    unit: 'ml',
    bitResolution: 1,
  },
  '490': { DDI: 490, name: 'Maximum Fuel Tank Content', unit: 'ml', bitResolution: 1 },
  '491': { DDI: 491, name: 'Fuel Percentage Level', unit: '0.00%', bitResolution: 0.01 },
  '492': { DDI: 492, name: 'Total Engine Hours', unit: 'h', bitResolution: 0.05 },
  '493': { DDI: 493, name: 'Lifetime Engine Hours', unit: 'h', bitResolution: 0.1 },
  '494': { DDI: 494, name: 'Last Event Partner ID (Byte 1-4)', unit: '', bitResolution: 1 },
  '495': { DDI: 495, name: 'Last Event Partner ID (Byte 5-8)', unit: 'n.a.', bitResolution: 1 },
  '496': { DDI: 496, name: 'Last Event Partner ID (Byte 9-12)', unit: 'n.a.', bitResolution: 1 },
  '497': { DDI: 497, name: 'Last Event Partner ID (Byte 13-16)', unit: '', bitResolution: 1 },
  '498': { DDI: 498, name: 'Last Event Partner ID Type', unit: 'n.a.', bitResolution: 1 },
  '499': {
    DDI: 499,
    name: 'Last Event Partner ID Manufacturer ID Code',
    unit: '',
    bitResolution: 1,
  },
  '500': { DDI: 500, name: 'Last Event Partner ID Device Class', unit: 'n.a.', bitResolution: 1 },
  '501': { DDI: 501, name: 'Setpoint Engine Torque', unit: '0.00%', bitResolution: 0.001 },
  '502': { DDI: 502, name: 'Actual Engine Torque', unit: '0.00%', bitResolution: 0.001 },
  '503': { DDI: 503, name: 'Minimum Engine Torque', unit: '0.00%', bitResolution: 0.001 },
  '504': { DDI: 504, name: 'Maximum Engine Torque', unit: '0.00%', bitResolution: 0.001 },
  '505': { DDI: 505, name: 'Tramline Control Level', unit: 'n.a.', bitResolution: 1 },
  '506': { DDI: 506, name: 'Setpoint Tramline Control Level', unit: 'n.a.', bitResolution: 1 },
  '507': { DDI: 507, name: 'Tramline Sequence Number', unit: 'n.a.', bitResolution: 1 },
  '508': {
    DDI: 508,
    name: 'Unique A-B Guidance Reference Line ID',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '509': { DDI: 509, name: 'Actual Track Number', unit: 'n.a.', bitResolution: 1 },
  '510': { DDI: 510, name: 'Track Number to the right', unit: 'n.a.', bitResolution: 1 },
  '511': { DDI: 511, name: 'Track Number to the left', unit: 'n.a.', bitResolution: 1 },
  '512': { DDI: 512, name: 'Guidance Line Swath Width', unit: 'mm', bitResolution: 1 },
  '513': { DDI: 513, name: 'Guidance Line Deviation', unit: 'mm', bitResolution: 1 },
  '514': { DDI: 514, name: 'GNSS Quality', unit: 'n.a.', bitResolution: 1 },
  '515': { DDI: 515, name: 'Tramline Control State', unit: 'n.a.', bitResolution: 1 },
  '516': { DDI: 516, name: 'Tramline Overdosing Rate', unit: 'ppm', bitResolution: 1 },
  '517': {
    DDI: 517,
    name: 'Setpoint Tramline Condensed Work State (1-16)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '518': {
    DDI: 518,
    name: 'Actual Tramline Condensed Work State (1-16)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '519': { DDI: 519, name: 'Last Bale Lifetime Count', unit: 'n.a.', bitResolution: 1 },
  '520': { DDI: 520, name: 'Actual Canopy Height', unit: 'mm', bitResolution: 1 },
  '521': { DDI: 521, name: 'GNSS Installation Type', unit: 'n.a.', bitResolution: 1 },
  '522': { DDI: 522, name: 'Twine Bale Total Count', unit: '#', bitResolution: 1 },
  '523': { DDI: 523, name: 'Mesh Bale Total Count', unit: '#', bitResolution: 1 },
  '524': { DDI: 524, name: 'Lifetime Twine Bale Total Count', unit: '#', bitResolution: 1 },
  '525': { DDI: 525, name: 'Lifetime Mesh Bale Total Count', unit: '#', bitResolution: 1 },
  '526': { DDI: 526, name: 'Actual Cooling Fluid Temperature', unit: 'mK', bitResolution: 1 },
  '528': { DDI: 528, name: 'Last Bale Capacity', unit: 'kg/h', bitResolution: 1 },
  '529': { DDI: 529, name: 'Setpoint Tillage Disc Gang Angle', unit: '°', bitResolution: 0.001 },
  '530': { DDI: 530, name: 'Actual Tillage Disc Gang Angle', unit: '°', bitResolution: 0.001 },
  '531': {
    DDI: 531,
    name: 'Actual Applied Preservative Per Yield Mass',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '532': {
    DDI: 532,
    name: 'Setpoint Applied Preservative Per Yield Mass',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '533': {
    DDI: 533,
    name: 'Default Applied Preservative Per Yield Mass',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '534': {
    DDI: 534,
    name: 'Minimum Applied Preservative Per Yield Mass',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '535': {
    DDI: 535,
    name: 'Maximum Applied Preservative Per Yield Mass',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '536': { DDI: 536, name: 'Total Applied Preservative', unit: 'ml', bitResolution: 1 },
  '537': { DDI: 537, name: 'Lifetime Applied Preservative', unit: 'ml', bitResolution: 1 },
  '538': {
    DDI: 538,
    name: 'Average Applied Preservative Per Yield Mass',
    unit: 'mm³/kg',
    bitResolution: 1,
  },
  '539': { DDI: 539, name: 'Actual Preservative Tank Volume', unit: 'ml', bitResolution: 1 },
  '540': { DDI: 540, name: 'Actual Preservative Tank Level', unit: 'ppm', bitResolution: 1 },
  '541': { DDI: 541, name: 'Actual PTO Speed', unit: 'r/min', bitResolution: 0.0001 },
  '542': { DDI: 542, name: 'Setpoint PTO Speed', unit: 'r/min', bitResolution: 0.0001 },
  '543': { DDI: 543, name: 'Default PTO Speed', unit: 'r/min', bitResolution: 0.0001 },
  '544': { DDI: 544, name: 'Minimum PTO Speed', unit: 'r/min', bitResolution: 0.0001 },
  '545': { DDI: 545, name: 'Maximum PTO Speed', unit: 'r/min', bitResolution: 0.0001 },
  '546': { DDI: 546, name: 'Lifetime Chopping Engagement Total Time', unit: 's', bitResolution: 1 },
  '547': {
    DDI: 547,
    name: 'Setpoint Bale Compression Plunger Load (N)',
    unit: 'N',
    bitResolution: 1,
  },
  '548': {
    DDI: 548,
    name: 'Actual Bale Compression Plunger Load (N)',
    unit: 'N',
    bitResolution: 1,
  },
  '549': {
    DDI: 549,
    name: 'Last Bale Average Bale Compression Plunger Load (N)',
    unit: 'N',
    bitResolution: 1,
  },
  '550': { DDI: 550, name: 'Ground Cover', unit: '0.00%', bitResolution: 0.1 },
  '551': { DDI: 551, name: 'Actual PTO Torque', unit: 'N*m', bitResolution: 0.0001 },
  '552': { DDI: 552, name: 'Setpoint PTO Torque', unit: 'N*m', bitResolution: 0.0001 },
  '553': { DDI: 553, name: 'Default PTO Torque', unit: 'N*m', bitResolution: 0.0001 },
  '554': { DDI: 554, name: 'Minimum PTO Torque', unit: 'N*m', bitResolution: 0.0001 },
  '555': { DDI: 555, name: 'Maximum PTO Torque', unit: 'N*m', bitResolution: 0.0001 },
  '556': { DDI: 556, name: 'Present Weather Conditions', unit: '', bitResolution: 1 },
  '557': { DDI: 557, name: 'Setpoint Electrical Current', unit: 'A', bitResolution: 0.005 },
  '558': { DDI: 558, name: 'Actual Electrical Current', unit: 'A', bitResolution: 0.005 },
  '559': { DDI: 559, name: 'Minimum Electrical Current', unit: 'A', bitResolution: 0.005 },
  '560': { DDI: 560, name: 'Maximum Electrical Current', unit: 'A', bitResolution: 0.005 },
  '561': { DDI: 561, name: 'Default Electrical Current', unit: 'A', bitResolution: 0.005 },
  '562': { DDI: 562, name: 'Setpoint Voltage', unit: 'V', bitResolution: 0.001 },
  '563': { DDI: 563, name: 'Default Voltage', unit: 'V', bitResolution: 0.001 },
  '564': { DDI: 564, name: 'Actual Voltage', unit: 'V', bitResolution: 0.001 },
  '565': { DDI: 565, name: 'Minimum Voltage', unit: 'V', bitResolution: 0.001 },
  '566': { DDI: 566, name: 'Maximum Voltage', unit: 'V', bitResolution: 0.001 },
  '567': { DDI: 567, name: 'Actual Electrical Resistance', unit: 'Ohm', bitResolution: 0.01 },
  '568': { DDI: 568, name: 'Setpoint Electrical Power', unit: 'W', bitResolution: 0.001 },
  '569': { DDI: 569, name: 'Actual Electrical Power', unit: 'W', bitResolution: 0.001 },
  '570': { DDI: 570, name: 'Default Electrical Power ', unit: 'W', bitResolution: 0.001 },
  '571': { DDI: 571, name: 'Maximum Electrical Power', unit: 'W', bitResolution: 0.001 },
  '572': { DDI: 572, name: 'Minimum Electrical Power', unit: 'W', bitResolution: 0.001 },
  '573': { DDI: 573, name: 'Total Electrical Energy', unit: 'kWh', bitResolution: 0.001 },
  '574': {
    DDI: 574,
    name: 'Setpoint Electrical Energy per Area Application Rate',
    unit: 'kWh/m²',
    bitResolution: 1e-7,
  },
  '575': {
    DDI: 575,
    name: 'Actual  Electrical Energy per Area Application Rate',
    unit: 'kWh/m²',
    bitResolution: 1e-7,
  },
  '576': {
    DDI: 576,
    name: 'Maximum  Electrical Energy  per Area Application Rate',
    unit: 'kWh/m²',
    bitResolution: 1e-7,
  },
  '577': {
    DDI: 577,
    name: 'Minimum  Electrical Energy per Area Application Rate',
    unit: 'kWh/m²',
    bitResolution: 1e-7,
  },
  '578': { DDI: 578, name: 'Setpoint Temperature', unit: 'mK', bitResolution: 1 },
  '579': { DDI: 579, name: 'Actual Temperature', unit: 'mK', bitResolution: 1 },
  '580': { DDI: 580, name: 'Minimum Temperature', unit: 'mK', bitResolution: 1 },
  '581': { DDI: 581, name: 'Maximum Temperature', unit: 'mK', bitResolution: 1 },
  '582': { DDI: 582, name: 'Default Temperature', unit: 'mK', bitResolution: 1 },
  '583': { DDI: 583, name: 'Setpoint Frequency ', unit: 'Hz', bitResolution: 0.001 },
  '584': { DDI: 584, name: 'Actual Frequency ', unit: 'Hz', bitResolution: 0.001 },
  '585': { DDI: 585, name: 'Minimum Frequency ', unit: 'Hz', bitResolution: 0.001 },
  '586': { DDI: 586, name: 'Maximum Frequency ', unit: 'Hz', bitResolution: 0.001 },
  '587': { DDI: 587, name: 'Previous Rainfall', unit: '', bitResolution: 1 },
  '588': {
    DDI: 588,
    name: 'Setpoint Volume Per Area Application Rate as [ml/m²]',
    unit: 'ml/m²',
    bitResolution: 0.1,
  },
  '589': {
    DDI: 589,
    name: 'Actual Volume Per Area Application Rate as [ml/m²]',
    unit: 'ml/m²',
    bitResolution: 0.1,
  },
  '590': {
    DDI: 590,
    name: 'Minimum Volume Per Area Application Rate as [ml/m²]',
    unit: 'ml/m²',
    bitResolution: 0.1,
  },
  '591': {
    DDI: 591,
    name: 'Maximum Volume Per Area Application Rate as [ml/m²]',
    unit: 'ml/m²',
    bitResolution: 0.1,
  },
  '592': {
    DDI: 592,
    name: 'Default Volume Per Area Application Rate as [ml/m²]',
    unit: 'ml/m²',
    bitResolution: 0.1,
  },
  '593': { DDI: 593, name: 'Traction Type', unit: 'n.a.', bitResolution: 1 },
  '594': { DDI: 594, name: 'Steering Type', unit: 'n.a.', bitResolution: 1 },
  '595': { DDI: 595, name: 'Machine Mode', unit: 'n.a.', bitResolution: 1 },
  '596': { DDI: 596, name: 'Cargo Area Cover State', unit: '0.00%', bitResolution: 1 },
  '597': { DDI: 597, name: 'Total Distance', unit: 'mm', bitResolution: 1 },
  '598': { DDI: 598, name: 'Lifetime Total Distance', unit: 'm', bitResolution: 1 },
  '599': { DDI: 599, name: 'Total Distance Field', unit: 'mm', bitResolution: 1 },
  '600': { DDI: 600, name: 'Lifetime Total Distance Field', unit: 'm', bitResolution: 1 },
  '601': { DDI: 601, name: 'Total Distance Street', unit: 'mm', bitResolution: 1 },
  '602': { DDI: 602, name: 'Lifetime Total Distance Street', unit: 'm', bitResolution: 1 },
  '603': {
    DDI: 603,
    name: 'Actual Tramline Condensed Work State (17-32)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '604': {
    DDI: 604,
    name: 'Actual Tramline Condensed Work State (33-48)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '605': {
    DDI: 605,
    name: 'Actual Tramline Condensed Work State (49-64)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '606': {
    DDI: 606,
    name: 'Actual Tramline Condensed Work State (65-80)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '607': {
    DDI: 607,
    name: 'Actual Tramline Condensed Work State (81-96)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '608': {
    DDI: 608,
    name: 'Actual Tramline Condensed Work State (97-112)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '609': {
    DDI: 609,
    name: 'Actual Tramline Condensed Work State (113-128)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '610': {
    DDI: 610,
    name: 'Actual Tramline Condensed Work State (129-144)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '611': {
    DDI: 611,
    name: 'Actual Tramline Condensed Work State (145-160)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '612': {
    DDI: 612,
    name: 'Actual Tramline Condensed Work State (161-176)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '613': {
    DDI: 613,
    name: 'Actual Tramline Condensed Work State (177-192)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '614': {
    DDI: 614,
    name: 'Actual Tramline Condensed Work State (193-208)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '615': {
    DDI: 615,
    name: 'Actual Tramline Condensed Work State (209-224)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '616': {
    DDI: 616,
    name: 'Actual Tramline Condensed Work State (225-240)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '617': {
    DDI: 617,
    name: 'Actual Tramline Condensed Work State (241-256)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '618': {
    DDI: 618,
    name: 'Setpoint Tramline Condensed Work State (17-32)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '619': {
    DDI: 619,
    name: 'Setpoint Tramline Condensed Work State (33-48)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '620': {
    DDI: 620,
    name: 'Setpoint Tramline Condensed Work State (49-64)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '621': {
    DDI: 621,
    name: 'Setpoint Tramline Condensed Work State (65-80)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '622': {
    DDI: 622,
    name: 'Setpoint Tramline Condensed Work State (81-96)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '623': {
    DDI: 623,
    name: 'Setpoint Tramline Condensed Work State (97-112)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '624': {
    DDI: 624,
    name: 'Setpoint Tramline Condensed Work State (113-128)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '625': {
    DDI: 625,
    name: 'Setpoint Tramline Condensed Work State (129-144)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '626': {
    DDI: 626,
    name: 'Setpoint Tramline Condensed Work State (145-160)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '627': {
    DDI: 627,
    name: 'Setpoint Tramline Condensed Work State (161-176)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '628': {
    DDI: 628,
    name: 'Setpoint Tramline Condensed Work State (177-192)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '629': {
    DDI: 629,
    name: 'Setpoint Tramline Condensed Work State (193-208)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '630': {
    DDI: 630,
    name: 'Setpoint Tramline Condensed Work State (209-224)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '631': {
    DDI: 631,
    name: 'Setpoint Tramline Condensed Work State (225-240)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '632': {
    DDI: 632,
    name: 'Setpoint Tramline Condensed Work State (241-256)',
    unit: 'n.a.',
    bitResolution: 1,
  },
  '633': {
    DDI: 633,
    name: 'Setpoint Volume per distance Application Rate',
    unit: 'ml/m',
    bitResolution: 0.001,
  },
  '634': {
    DDI: 634,
    name: 'Actual Volume per distance Application Rate',
    unit: 'ml/m',
    bitResolution: 0.001,
  },
  '635': {
    DDI: 635,
    name: 'Default Volume per distance Application Rate',
    unit: 'ml/m',
    bitResolution: 0.001,
  },
  '636': {
    DDI: 636,
    name: 'Minimum Volume per distance Application Rate',
    unit: 'ml/m',
    bitResolution: 0.001,
  },
  '637': {
    DDI: 637,
    name: 'Maximum Volume per distance Application Rate',
    unit: 'ml/m',
    bitResolution: 0.001,
  },
  '638': { DDI: 638, name: 'Setpoint Tire Pressure', unit: 'Pa', bitResolution: 0.1 },
  '639': { DDI: 639, name: 'Actual Tire Pressure', unit: 'Pa', bitResolution: 0.1 },
  '640': { DDI: 640, name: 'Default Tire Pressure', unit: 'Pa', bitResolution: 0.1 },
  '641': { DDI: 641, name: 'Minimum Tire Pressure', unit: 'Pa', bitResolution: 0.1 },
  '642': { DDI: 642, name: 'Maximum Tire Pressure', unit: 'Pa', bitResolution: 0.1 },
  '57342': { DDI: 57342, name: 'PGN Based Data', unit: 'n.a.', bitResolution: 1 },
  '57343': { DDI: 57343, name: 'Request Default Process Data', unit: 'n.a.', bitResolution: 1 },
};

export default entities;
